import React from 'react';
import { TextInput, required } from 'react-admin';
import { FieldArray } from 'react-final-form-arrays';
import { makeStyles } from '@material-ui/core/styles';

import ImageInput from './UploadInputs/ImageInput';
import { uploadTypes } from '../config/constants';

const useStyles = makeStyles({
  customFormField: {
    width: 256,
  },
});

const textAnswersList = ({ fields, classes }) => {
  const answersList = (
    <>
      {fields.map((member) => (
        <div key={`${member}.answer`}>
          <TextInput
            key={member}
            source={`${member}.answer`}
            label="Answer for question"
            className={classes.customFormField}
            validate={required()}
          />
        </div>
      ))}
    </>
  );

  return answersList;
};

const getFieldName = (member, name) => {
  if (!member) {
    return name;
  }

  return `${member}.${name}`;
};

const PersonalityQuizQuestion = ({ member, questionFormType }) => {
  const classes = useStyles();

  return (
    <>
      <TextInput
        source={getFieldName(member, 'text')}
        label="Question"
        className={classes.customFormField}
        validate={required()}
      />
      <br />
      <FieldArray name={getFieldName(member, 'answers')} classes={classes}>
        {textAnswersList}
      </FieldArray>

      <ImageInput uploadType={uploadTypes.quiz} imageInputSource={getFieldName(member, 'image')} validate={required()} />
    </>
  );
};

export default PersonalityQuizQuestion;
